import API_URLS from '../config/apiConfig';
import type { StoreListQuery, StoreListResponse } from '../types/store';
import { apiGet } from '../utils/apiUtils';
import { isSuperAdmin } from '../utils/auth/currentUser';
import { buildQueryString } from '../utils/buildQueryString';

class StoreService {
  async getStores(params?: StoreListQuery): Promise<StoreListResponse> {
    const getAll = params?.get_all;
    const baseUrl = getAll || !isSuperAdmin() ? API_URLS.GET_STORES : API_URLS.GET_ADMIN_STORES;

    const query = buildQueryString({
      subscription_status: params?.subscription_status && params.subscription_status !== 'all' ? params.subscription_status : undefined,
      store_status: params?.store_status || undefined,
      search: params?.search || undefined,
      get_all: getAll ? 'true' : undefined,
      page: params?.page && params.page > 0 ? params.page : undefined,
      page_size: params?.page_size && params.page_size > 0 ? params.page_size : undefined,
    });

    const finalUrl = query ? `${baseUrl}?${query}` : baseUrl;
    const response = await apiGet(finalUrl);
    const rawResponse = response as Partial<StoreListResponse> & { stores?: unknown };
    const stores = Array.isArray(rawResponse.stores)
      ? rawResponse.stores
      : Array.isArray(response)
        ? response
        : [];
    const totalStores = typeof rawResponse.total_stores === 'number' ? rawResponse.total_stores : stores.length;
    const page = typeof rawResponse.page === 'number' ? rawResponse.page : params?.page || 1;
    const pageSize = typeof rawResponse.page_size === 'number' ? rawResponse.page_size : params?.page_size || stores.length || 10;
    const totalPages = typeof rawResponse.total_pages === 'number'
      ? rawResponse.total_pages
      : Math.max(1, Math.ceil(totalStores / (pageSize || 1)));

    return {
      stores: stores as StoreListResponse['stores'],
      total_stores: totalStores,
      page,
      page_size: pageSize,
      total_pages: totalPages,
      has_next: typeof rawResponse.has_next === 'boolean' ? rawResponse.has_next : page < totalPages,
      has_previous: typeof rawResponse.has_previous === 'boolean' ? rawResponse.has_previous : page > 1,
    };
  }
}

const storeService = new StoreService();
export default storeService;
